import { createTheme } from '@mui/material/styles';

declare module '@mui/material/styles' {
  interface Palette {
    orange: Palette['primary'];
    dark: {
      main: string;
      secondary: string;
      hover: string;
      inactive: string;
      border: string;
      background: string;
    };
    blue: Palette['primary'];
    white: Palette['primary'];
    yellow: Palette['primary'];
    green: Palette['primary'];
    border: {
      main: string;
      active: string;
    };
    button: {
      main: string;
      contrast: string;
    };
    label: {
      main: string;
      gray: string;
    };
  }

  interface PaletteOptions {
    orange?: PaletteOptions['primary'];
    dark?: {
      main: string;
      secondary: string;
      hover: string;
      inactive: string;
      border: string;
      background: string;
    };
    blue?: PaletteOptions['primary'];
    white?: PaletteOptions['primary'];
    yellow?: PaletteOptions['primary'];
    green?: PaletteOptions['primary'];
    border?: {
      main: string;
      active: string;
    };
    button?: {
      main: string;
      contrast: string;
    };
    label?: {
      main: string;
      gray: string;
    };
  }

  interface TypeBackground {
    footer: string;
  }
}

const theme = createTheme({
  palette: {
    orange: {
      main: '#FF9700',
      light: '#FF5A241A',
    },
    dark: {
      main: '#343434',
      secondary: '#474748',
      hover: '#232324',
      inactive: '#757576',
      border: '#F1F1F1',
      background: '#FBFBFB',
    },
    blue: {
      main: '#75E6FF',
      light: '#3B7CDE1A',
    },
    white: {
      main: '#FFFFFF',
    },
    yellow: {
      main: '#F79E1B',
      light: '#F79E1B1A',
    },
    green: {
      main: '#BAFF2A',
      dark: '#7EBB00',
      light: '#C1FE40',
    },
    background: {
      default: '#f0f4f8',
      footer: '#d0d4e8',
    },
    border: {
      main: '#e1e5e9',
      active: '#85a6ee',
    },
    button: {
      main: '#2462ea',
      contrast: '#2b75ff',
    },
    label: {
      main: '',
      gray: '',
    },
  },
  typography: {
    fontFamily: 'Arimo',
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 600,
    fontWeightBold: 900,
    body1: {
      lineHeight: '130%',
      letterSpacing: '1%',
    },
  },
});

export default theme;
